<footer class="footer mt-auto py-3 bg-light overall-site-layout" id="footer">
  <div class="container" >
    <div class="row mt-4">
      <div class="col-md-4 mt-3">

        <b>VERLANGLIJST ONLINE</b>
        <ul class="list-nostyle">
          <li>
            <a routerLink="/">Verlanglijstje maken</a>
          </li>
          <li>
            <a routerLink="/lootjestrekken">Lootjes trekken</a>
          </li>
          <li>
            <a routerLink="/catalogus">Cadeauzoeker</a>
          </li>
          <li>
            <a routerLink="/help">Help</a>
          </li>
          <li>
            <a routerLink="/contact">Contact</a>
          </li>
          <li>
            <a routerLink="/auth/aanmelden">Gratis aanmelden</a>
          </li>
          <li>
            <a routerLink="/auth/inloggen">Inloggen</a>
          </li>
        </ul>
      </div>

      <div class="col-md-4 mt-3">
        <b>VERLANGLIJSTJES THEMA'S</b>
        <ul class="list-nostyle">
          <li>
            <a routerLink="/verjaardagslijstje">Verjaardag</a>
          </li>
          <li>
            <a routerLink="/baby">Baby</a>
          </li>
          <li>
            <a routerLink="/bruiloft">Bruiloft</a>
          </li>
          <li>
            <a routerLink="/sinterklaas">Sinterklaas</a>
          </li>
          <li>
            <a routerLink="/kerst">Kerst</a>
          </li>
          <li>
            <a routerLink="/meer">en meer...</a>
          </li>

        </ul>

      </div>

      <div class="col-md mt-3">
        <b>VOLG ONS</b>
        <ul class="list-nostyle">
          <li>
            <a href="https://www.facebook.com/verlanglijstonline" target="_blank" rel="noreferrer noopener"><img
                src="../assets/iconsInApp/social_facebook.png" height="40" width="40"
                alt="verlanglijst.online op Facebook"></a>
          </li>
        </ul>

        <ul class="list-nostyle">
          <li>
            <a routerLink="/voorwaarden">Gebruiksvoorwaarden</a>
          </li>
          <li>
            <a routerLink="/privacy">Privacybeleid</a>
          </li>
          <li>
            <a routerLink="/cookiebeleid">Cookiebeleid</a>
          </li>
        </ul>

      </div>

    </div>

    <div class="row  mt-3 mb-5">
      <div class="col">
        &#169; {{currentDate | date: "y" }} Verlanglijst.online


      </div>
    </div>
  </div>

</footer> 